export {default} from './SpinningSlider';
